import { Person } from '@common/entities';
import { WhereFilter } from '@common/filter.decorator';

import { PersonFilterForm } from 'src/app/@shared/form/form.types';
import { PersonSource } from 'src/app/person/@shared/person.model';

export type PersonFilterResultForWhere = Partial<Pick<PersonFilterForm,
'addressFederalState' | 'qualifications' | 'media'>>;

function getStringArrayFromContainsFilter(value: unknown): string[] {
  if (!value || typeof value !== 'object' || Array.isArray(value)) {
    return [];
  }

  if (!Array.isArray((value as { contains?: unknown }).contains)) {
    return [];
  }

  return ((value as { contains: unknown[] }).contains || [])
    .filter((item): item is string => {
      return typeof item === 'string';
    });
}

export function getPersonWhereFilterByFilterResult(filterResult: PersonFilterResultForWhere): WhereFilter<PersonSource> {
  const where: WhereFilter<PersonSource> = {};

  if (filterResult.addressFederalState) {
    where.addressFederalState = filterResult.addressFederalState;
  }

  if (filterResult.qualifications?.length) {
    where.qualifications = {
      contains: filterResult.qualifications,
    };
  }

  if (filterResult.media?.length) {
    where.media = {
      contains: filterResult.media,
    };
  }

  return where;
}

export function getPersonFilterResultByWhereFilter(whereFilter: WhereFilter<Person> | undefined): PersonFilterResultForWhere {
  if (!whereFilter) {
    return {};
  }

  const filterResult: PersonFilterResultForWhere = {};

  if (whereFilter.addressFederalState) {
    filterResult.addressFederalState = whereFilter.addressFederalState as string;
  }

  const qualifications = getStringArrayFromContainsFilter(whereFilter.qualifications);

  if (qualifications.length) {
    filterResult.qualifications = qualifications;
  }

  const media = getStringArrayFromContainsFilter(whereFilter.media);

  if (media.length) {
    filterResult.media = media;
  }

  return filterResult;
}
